import _ from "lodash";
import {$t} from "../translator";

/**
 * validating a field:
 *
 * @param value: value of the field to validate
 * @param rulesArr: array of the rules function should validate
 * @returns {*[]} : returns array of text errors to display to the user
 *
 * Example:
 * $validate( 'aloniado', ['maxLength(3)', 'minLength(2)', numeric]
 * returns: ['Length should not exceed {3} characters', 'Value must be numeric']        // minLength requirement is met. no error added to array for it
 *
 * Rule options:
 * required,
 * minLength(X),
 * maxLength(X),
 * email,
 * numeric,
 * id,
 * name,
 * phone,
 * max(X),
 * min(X)
 * integer
 * password
 * match(X)     //matches an exact string provided
 */

export function $validate(value, rulesArr) {
    // console.log(rulesArr)
    let errors = [];

    _.forEach(rulesArr, (v, k) => {
        if (v === 'required') {
            // console.log(value, typeof value, value.length)
            if ((typeof value === 'string' && !value.length) || (typeof value === 'undefined')) {
                errors.push($t('validation.general.required'))
            }
        }
        if (v.search(/minLength/) >= 0) {
            let length = v.replace(/[^0-9]/g, '');
            if (value.length < length && value.length !== 0) {
                errors.push($t('validation.general.minLength', [length]))
            }
        }
        if (v.search(/maxLength/) >= 0) {
            let length = v.replace(/[^0-9]/g, '');
            if (value.length > length) {
                errors.push($t('validation.general.maxLength', [length]))
            }
        }
        if (v === 'email') {
            if (!(/^(\s*|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))+$/).test(value)) {
                errors.push($t('validation.general.email'))
            }
            // if (!(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/).test(value)) {
            //     errors.push($t('validation.general.email'))
            // }
        }
        if (v === 'numeric') {
            if (isNaN(value)) {
                errors.push($t('validation.general.numeric'))
            }
            // if(!(/^(\s*|\d+)$/).test(value)) {
            //     errors.push($t('validation.general.numeric'))
            // }
        }
        if (v === 'id') {
            if (!(/^(\s*|[a-zA-Z0-9\.\-]*)$/).test(value)) {
                errors.push($t('validation.general.id'))
            }
        }
        if (v === 'name') {
            if (!(/^(\s*|[{\p{L}} ,.'-]+)$/u).test(value)) {
                errors.push($t('validation.general.name'))
            }
        }

        if (v === 'phone') {
            if (!(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im).test(value)) {
                errors.push($t('validation.general.phoneNumber'))
            }
        }

        if (v.search(/max\(/) >= 0) {
            let max = v.substring(
                v.indexOf("(") + 1,
                v.lastIndexOf(")")
            );
            // let max = parseInt(v.replace(/[^0-9]/g, ''));
            let numValue = parseInt(value)

            if (numValue > max) {
                errors.push($t('validation.general.max', [max]))
            }
        }

        if (v.search(/min\(/) >= 0) {
            let min = v.substring(
                v.indexOf("(") + 1,
                v.lastIndexOf(")")
            );
            // let min = parseInt(v.split(/[()]/))
            // let min = parseInt(v.replace(/[^0-9]/g, ''));
            let numValue = parseInt(value)
            // console.log(value, min)

            if (numValue < min) {
                errors.push($t('validation.general.min', [min]))
            }
        }

        if (v === 'password') {
            // console.log(value,(/(?=.*[0-9].*).+$/).test(value), (/(?=.*[A-Z].*).+$/).test(value), (/(?=.*[a-z].*).+$/).test(value))

            if (value.length < 8) {
                errors.push($t('validation.general.minLength', [8]))
            }
            if (!(/(?=.*[A-Z].*).+$/).test(value)) {
                errors.push($t('validation.general.mustContainUppercaseCharacters'))
            }
            if (!(/(?=.*[a-z].*).+$/).test(value)) {
                errors.push($t('validation.general.mustContainLowercaseCharacters'))
            }
            if (!(/(?=.*[0-9].*).+$/).test(value)) {
                errors.push($t('validation.general.mustContainDigits'))
            }

        }

        if (v === 'integer') {
            // console.log(value,(/(?=.*[0-9].*).+$/).test(value), (/(?=.*[A-Z].*).+$/).test(value), (/(?=.*[a-z].*).+$/).test(value))
            if (!(/^([-]?[1-9]\d*|0)$/).test(value)) {
                errors.push($t('validation.general.integer'))
            }
        }

        if (v.search(/match\(/) >= 0) {
            let strToMatch = v.substring(
                v.indexOf("(") + 1,
                v.lastIndexOf(")")
            );
            // console.log('strToMatch', strToMatch)

            if (value !== strToMatch) {
                errors.push($t('validation.general.noMatch'))
            }
        }

    })

    return errors;
}


